export const STATES = {
  AC: { name: 'Acre', region: 'norte' },
  AL: { name: 'Alagoas', region: 'nordeste' },
  AP: { name: 'Amapá', region: 'norte' },
  AM: { name: 'Amazonas', region: 'norte' },
  BA: { name: 'Bahia', region: 'nordeste' },
  CE: { name: 'Ceará', region: 'nordeste' },
  DF: { name: 'Distrito Federal', region: 'centro_oeste' },
  ES: { name: 'Espírito Santo', region: 'sudeste' },
  GO: { name: 'Goiás', region: 'centro_oeste' },
  MA: { name: 'Maranhão', region: 'nordeste' },
  MT: { name: 'Mato Grosso', region: 'centro_oeste' },
  MS: { name: 'Mato Grosso do Sul', region: 'centro_oeste' },
  MG: { name: 'Minas Gerais', region: 'sudeste' },
  PA: { name: 'Pará', region: 'norte' },
  PB: { name: 'Paraíba', region: 'nordeste' },
  PR: { name: 'Paraná', region: 'sul' },
  PE: { name: 'Pernambuco', region: 'nordeste' },
  PI: { name: 'Piauí', region: 'nordeste' },
  RJ: { name: 'Rio de Janeiro', region: 'sudeste' },
  RN: { name: 'Rio Grande do Norte', region: 'nordeste' },
  RS: { name: 'Rio Grande do Sul', region: 'sul' },
  RO: { name: 'Rondônia', region: 'norte' },
  RR: { name: 'Roraima', region: 'norte' },
  SC: { name: 'Santa Catarina', region: 'sul' },
  SP: { name: 'São Paulo', region: 'sudeste' },
  SE: { name: 'Sergipe', region: 'nordeste' },
  TO: { name: 'Tocantins', region: 'norte' },
};

export const REGION_META = {
  norte: { label: 'Norte', color: 'emerald' },
  nordeste: { label: 'Nordeste', color: 'amber' },
  centro_oeste: { label: 'Centro-Oeste', color: 'orange' },
  sudeste: { label: 'Sudeste', color: 'blue' },
  sul: { label: 'Sul', color: 'indigo' },
};

export const AGE_META = {
  '18-24': { label: '18–24 anos' },
  '25-34': { label: '25–34 anos' },
  '35-44': { label: '35–44 anos' },
  '45-54': { label: '45–54 anos' },
  '55-64': { label: '55–64 anos' },
  '65+': { label: '65+ anos' },
};

export const GENDER_META = {
  masculino: { label: 'Masculino', color: 'bg-blue-100 text-blue-700' },
  feminino: { label: 'Feminino', color: 'bg-pink-100 text-pink-700' },
  outro: { label: 'Outro', color: 'bg-slate-100 text-slate-700' },
};

export const AFFINITY_META = {
  apoiador: { label: 'Apoiador', color: 'bg-emerald-100 text-emerald-700' },
  neutro: { label: 'Neutro', color: 'bg-slate-100 text-slate-700' },
  critico: { label: 'Crítico', color: 'bg-amber-100 text-amber-700' },
  opositor: { label: 'Opositor', color: 'bg-rose-100 text-rose-700' },
};

export const stateName = uf => STATES[uf]?.name || uf;
export const regionLabel = r => REGION_META[r]?.label || r;
